module.exports = "/lucky-balls/img/weager/balls/normal/LB_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/normal/LB_2.png
// module id = 1185
// module chunks = 0